// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Clientes_DocumentConfigInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET /clientes/document_config
 *
 * Validates document configuration requests. All fields optional.
 */
import { registerContract } from './validate'

export interface Clientes_DocumentConfigInput {
franquia_id?: number
}

registerContract('Clientes_DocumentConfigInput', {
  franquia_id: { type: 'number',  required: false },
})
